<template>
  <a-tooltip placement="left">
    <template v-if="auditorName" slot="title">
      <p>审核人: {{ auditorName }}</p>
      <p>审核时间: {{ auditTime }}</p>
    </template>
    <template v-else slot="title">
      <p>审核人: --</p>
      <p>审核时间: --</p>
    </template>
    <a-icon class="tip-icon" type="exclamation-circle" style="padding-top: 4px" />
  </a-tooltip>
</template>
<script>

export default {
  name: 'RightConsumeTip',
  props: {
    auditorName: {
      type: String,
      default: () => ''
    },
    // 剩余名额
    auditTime: {
      type: String,
      default: () => ''
    }
  }
}
</script>